module.exports = __webpack_public_path__ + "static/media/melroseyouthfootball.com.24dfe92d.png";